<template>
  <div class="app-wrapper">
    <!-- Password Overlay -->
    <div v-if="siteLockEnabled && !authenticated" class="password-lock-overlay">
      <div class="lock-card">
        <h2>🔒 Protected Site</h2>
        <p>Please enter the password to access this site</p>

        <input
          v-model="inputPassword"
          type="password"
          placeholder="Enter password"
          @keyup.enter="checkPassword"
        />
        <button @click="checkPassword">Enter</button>

        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </div>

    <!-- Main Layout -->
    <template v-else>
      <the-navigation></the-navigation>

      <router-view></router-view>

      <the-Footer></the-Footer>
      <CookieBanner />
    </template>
  </div>
</template>

<script>
import TheNavigation from './components/Layout/TheNavigation.vue';
import TheFooter from './components/Layout/TheFooter.vue';
import CookieBanner from './components/UI/CookieBanner.vue';

const ENABLE_SITE_LOCK = true; //set true ONLY when prod / staging URL needs password protection
const FORCE_LOCK_ON_LOCAL = false; // 🔁 set true ONLY when testing locally

export default {
  components: {
    TheNavigation,
    TheFooter,
    CookieBanner,
  },

  data() {
    const allowedHosts = ['localhost', 'nestlebksweepsen.snipp.us','nestlebksweepsfr.snipp.us','',''];

    const isLocalhost = allowedHosts.includes(window.location.hostname);

    const shouldLock =
      ENABLE_SITE_LOCK && (!isLocalhost || FORCE_LOCK_ON_LOCAL);

    return {
      isLocalhost,
      siteLockEnabled: shouldLock,
      authenticated:
        !shouldLock || sessionStorage.getItem('authPassed') === 'true',
      inputPassword: '',
      error: '',
    };
  },

  methods: {
    checkPassword() {
      const password = '*kw1D#K35r';

      if (this.inputPassword === password) {
        this.authenticated = true;
        sessionStorage.setItem('authPassed', 'true');
        this.error = '';
      } else if (!this.inputPassword) {
        this.error = 'Please enter a password!';
      } else {
        this.error = 'Wrong password! Try again.';
        this.inputPassword = '';
      }
    },
  },
};
</script>

<style>
/* Overlay background */
.password-lock-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom right, #4e54c8, #8f94fb);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  font-family: 'Arial', sans-serif;
  color: #333;
}

/* Card in center */
.lock-card {
  background: #fff;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: 350px;
  max-width: 90%;
  animation: fadeIn 0.5s ease-in-out;
}

/* Heading */
.lock-card h2 {
  margin-bottom: 10px;
  font-size: 24px;
  color: #4e54c8;
}

/* Paragraph */
.lock-card p {
  margin-bottom: 20px;
  font-size: 14px;
  color: #555;
}

/* Input field */
.lock-card input {
  width: 100%;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 15px;
  outline: none;
  transition: all 0.2s ease;
}
.lock-card input:focus {
  border-color: #4e54c8;
  box-shadow: 0 0 5px rgba(78, 84, 200, 0.5);
}

/* Button */
.lock-card button {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  background-color: #4e54c8;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.lock-card button:hover {
  background-color: #3b40a4;
}

/* Error message */
.lock-card .error {
  margin-top: 10px;
  color: #e74c3c;
  font-size: 13px;
}

/* Fade-in animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
